import { Suspense } from "react";
import { Route, Routes, useNavigate } from "react-router";
import { useTypedParams } from "react-router-typesafe-routes";

import { PageLoading } from "~/components/loading";
import { v2Route } from "~/v2/routes";
import { ChangeRequestDetail } from "./components/ChangeRequestDetail";
import { ChangeRequestsContainer } from "./components/changeRequests.container";

function ChangeRequestDetailRoute() {
  const { id = "" } = useTypedParams(v2Route.changeRequests.detail);
  const navigate = useNavigate();
  return <ChangeRequestDetail id={id} onBack={() => navigate("..")} />;
}

export function ChangeRequestsRoutes() {
  return (
    <Suspense fallback={<PageLoading />}>
      <Routes>
        <Route index element={<ChangeRequestsContainer />} />
        <Route path=":id" element={<ChangeRequestDetailRoute />} />
      </Routes>
    </Suspense>
  );
}
